import type { ColumnChartDataItems } from "pro-features/components/Chart/src/types";
import type { ValueOf } from "pro-features/types";

interface IArgs {
    displayValue: string;
    x: number;
    y: number;
    shape?: string;
    anchorX?: number;
    anchorY?: number;
    useHTML?: boolean;
    baseline?: boolean;
    className?: string;
}

export const resolveHighChartLabelProps = (args: IArgs): (ValueOf<IArgs> | null)[] => {
    const {
        displayValue,
        x,
        y,
        shape = null,
        anchorX = null,
        anchorY = null,
        useHTML = null,
        baseline = null,
        className = null,
    } = args;
    return [displayValue, x, y, shape, anchorX, anchorY, useHTML, baseline, className];
};

const MAX_Y_AXIS_VALUE_MULTIPLIER = 1.3;
export const resolveMaxYaxisValue = (series: ColumnChartDataItems) => {
    // set the max Y axis value to MAX_Y_AXIS_VALUE_MULTIPLIER
    // more than the maximum value in order to have enough space for custom data labels
    return Math.max(...series.map(({ y }) => (isNaN(y) ? 0 : y))) * MAX_Y_AXIS_VALUE_MULTIPLIER;
};
